import { StyleSheet, View } from 'react-native';

import Colors from '@omni/kit/theming/Colors';
import { IconName } from '@omni/kit/components/KitIcon';
import { KitTouchableIcon } from '@omni/kit/components';
import React from 'react';

interface IconTabButtonProps {
  isActive?: boolean;
  name: IconName;
  onPress?: () => void;
  size?: number;
}

export default function IconTabButton({
  isActive,
  name,
  onPress,
  size = 25,
}: IconTabButtonProps): JSX.Element {
  const color = isActive ? Colors.N900 : Colors.N300;

  return (
    <View style={styles.wrapper}>
      <KitTouchableIcon
        name={name}
        onPress={onPress}
        size={size}
        color={color}
        testID={`icon-tab-button-${name}`}
      />
      {isActive && <View style={styles.underline} />}
    </View>
  );
}

const styles = StyleSheet.create({
  underline: {
    backgroundColor: Colors.N900,
    bottom: -1,
    height: 2,
    left: 6,
    position: 'absolute',
    width: 45,
  },
  wrapper: {
    height: '100%',
    justifyContent: 'center',
  },
});
